import { withResult } from 'feathers-fletching';
import { disallow } from 'feathers-hooks-common';
import { withSearch } from 'src/feathers/hooks';

const withSearches = withSearch({
  '$shipment.carrier.name$': withSearch.string,
  '$shipment.pickup_address.city$': withSearch.string,
  '$shipment.pickup_address.name$': withSearch.string,
  '$shipment.delivery_address.city$': withSearch.string,
  '$shipment.delivery_address.name$': withSearch.string,
  '$shipment.reference_number$': withSearch.text,
  '$shipment.id$': withSearch.number,
  id: withSearch.number
});

const withResults = withResult({
  charges: async (invoice, context) => {
    if (
      !context.params.$include?.includes('payment_method') ||
      !invoice.charges?.length
    ) {
      return invoice.charges;
    }

    const chargesWithPayments = await Promise.all(
      invoice.charges.map(async (charge) => {
        const payment = await context.params.loader
          .service('api/payment-methods')
          .load(charge.payment_method_id);

        return {
          ...charge,
          payment_method: payment
        };
      })
    );

    return chargesWithPayments;
  },
  shipment: async (invoice, context) => {
    if (
      !context.params.$include?.includes('shipment') ||
      !invoice.shipment_id
    ) {
      return undefined;
    }

    const shipment = await context.params.loader
      .service('api/shipments')
      .load(invoice.shipment_id);

    return shipment;
  }
});

export default {
  before: {
    all: [withSearches],
    find: [],
    get: [],
    create: [disallow()],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [withResults],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
